import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import { setReportTagsFilter } from '../../../../../../../../../../services/redux/actions';
import allowedDevicesService from '../../../../../../../../../../services/allowedDevices';
import { injectIntl } from 'react-intl';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import { grey400 } from 'material-ui/styles/colors';
import withQueryStringProps from '../../../../../../../../../../components/withQueryStringProps';
import HideIfPrint from '../../../../../../../../../../components/HideIfPrint';
import ShowIfPrint from '../../../../../../../../../../components/ShowIfPrint';
import _ from 'lodash';


const styles = {
  deviceSelectField: {
    verticalAlign: 'middle',
    width: 350,
    icon: {
      fill: grey400,
    },
    underline: {
      borderColor: grey400,
    },
  },
};

@withQueryStringProps(['selectedTags'])
@injectIntl
@connect()
class TagPicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTags: this.props.selectedTags ? this.props.selectedTags.map(item => item === '' ? null : item) : [],
    };
  }

  dispatchTagsFilterAction = () => {

    const allowedDevices = allowedDevicesService.getAllowedDevices(this.props.relayDevices, this.props.viewer.devices, this.props.report.devices);
    const deviceIdsByTags = allowedDevices.filter(d => _.intersection(d.tags, this.state.selectedTags).length);
    this.props.dispatch(setReportTagsFilter(this.props.report.id, deviceIdsByTags));
  };

  handleSelectedTagsChange = (event, index, values) => {

    if (values.length === 0) {
      this.setState({ selectedTags: [null] });
    } else if (_.includes(this.state.selectedTags, null) && values.length > 1) {
      this.setState({ selectedTags: _.without(values, null) });
    } else if (_.includes(values, null)) {
      this.setState({ selectedTags: [null] });
    } else {
      this.setState({ selectedTags: values });
    }

  };

  setTagsQueryString = () => {
    if (!this.state.selectedTags || _.isEqual(this.state.selectedTags.filter(Boolean), [])) {
      this.props.qs.set({ selectedTags: null });
    } else {
      this.props.qs.set({ selectedTags: this.state.selectedTags.filter(Boolean) });
    }
  };

  componentDidMount() {
    this.setTagsQueryString();
    this.dispatchTagsFilterAction();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !_.isEqual(prevState.selectedTags, this.state.selectedTags) ||
      !_.isEqual(prevProps.report.devices, this.props.report.devices)
    ) {
      this.setTagsQueryString();
      this.dispatchTagsFilterAction();
    }
  }

  render() {

    const selectedTags = this.state.selectedTags;

    const deviceTags = _(allowedDevicesService.getAllowedDevices(this.props.relayDevices, this.props.viewer.devices, this.props.report.devices)).map('tags').flatten().uniq().sort().value().filter(Boolean);

    if (deviceTags.length <= 1) {
      return null;
    } else {
      return (
        <div>
          <HideIfPrint>
            <SelectField
              floatingLabelText={this.props.intl.formatMessage({ id: 'filterBySubject' })}
              multiple={true}
              value={(selectedTags && !selectedTags.filter(Boolean).length) ? null : selectedTags}
              onChange={this.handleSelectedTagsChange}
              autoWidth={true}
              style={styles.deviceSelectField}
              iconStyle={styles.deviceSelectField.icon}
              underlineStyle={styles.deviceSelectField.underline}
            >
              {
                !(selectedTags && !selectedTags.filter(Boolean).length) &&
                <MenuItem
                  key={null}
                  value={null}
                  primaryText={this.props.intl.formatMessage({ id: 'clearSelectedSubjects' })}
                  insetChildren={true}
                  checked={selectedTags.indexOf(null) > -1}
                />
              }
              {
                !(selectedTags && !selectedTags.filter(Boolean).length) &&
                <Divider />
              }
              {deviceTags.map(item =>
                <MenuItem
                  key={item}
                  value={item}
                  primaryText={item}
                  insetChildren={true}
                  checked={selectedTags.indexOf(item) > -1}
                />
              )}
            </SelectField>
          </HideIfPrint>
          <ShowIfPrint>
            <span>
              {(selectedTags && selectedTags.constructor === Array && (selectedTags.filter(Boolean)).length) &&
                <span style={{ display: 'block', marginBottom: '12px' }}>
                  <span style={{ fontWeight: 'bold' }}>
                    {this.props.intl.formatMessage({ id: 'tags' }) + ': '}
                  </span>
                  {selectedTags ? selectedTags.filter(Boolean).join(', ') : ''}
                </span>
              }
            </span>
          </ShowIfPrint>
        </div>
      );
    }
  }
}

export default createFragmentContainer(
  TagPicker,
  graphql`
    fragment TagPicker_viewer on Viewer {
      devices {
        id
        tags
      }
    }
    fragment TagPicker_report on Report {
      id
      devices {
        id
        tags
      }
    }
    fragment TagPicker_relayDevices on DeviceConnection {
      edges {
        node {
          id
          tags
        }
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/components/ReportFilters/components/TagPicker/TagPicker.js